import styles from "./RetiredMark.module.css";

type RetiredMarkProps = {
  value: string;
  isRetired: boolean;
  // "archived" for skills, "inactive" for topics — the word the record's own
  // listing uses for that state.
  note: string;
};

export const RetiredMark = ({ value, isRetired, note }: RetiredMarkProps) =>
  isRetired ? (
    <span className={styles.value}>
      {value}
      <span className={styles.note}>{note}</span>
    </span>
  ) : (
    value
  );
